import React from "react";
import UserCard from "./AdminDashBoard/UserCard";
import { Helmet } from "react-helmet";

const DashboardHome = () => {
  return (
    <>
      <Helmet>
        <title>Dashboard - My Dashboard</title>
        <meta
          name="description"
          content="Complete your order on with our simple and secure checkout process. Enjoy instant access to your digital products after payment."
        />
      </Helmet>
      <div className="container">
        <div className="row mb-4"></div>
        <UserCard />
      </div>
    </>
  );
};

export default DashboardHome;
